import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import globals from '../globals.js';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PopUpMenu from './popUpMenu.jsx';
import Grid from '@mui/material/Grid';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import RedButton from '../components/redButton.jsx';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useAuth } from '../context/AuthContext';
import { useState, useEffect } from 'react';
import BlueButton from '../components/blueButton.jsx';
import { useNavigate } from 'react-router-dom';

export default function AccountMenuDektop() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  // Customization of the menu button
  const MenuButton = styled(Button)(() => ({
    color: globals.colors.lightRed,
    '&:hover': {
      backgroundColor: 'transparent',
      color: globals.colors.darkRed,
    },
    '&.Mui-selected': {
      color: globals.colors.darkRed,
    },
  }))

  return (
    <React.Fragment>
      {/* Grid to separate the two columns - logo and navbar */}
      <Grid container justifyContent={'space-around'}>
        {/* Logo */}
        <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
          <a href='/'><img
            src={'/eacademiabg-logo.webp'}
            alt='Лого на eAcademiaBg'
            title='eAcademiaBg – Онлайн уроци за всеки'
            style={{ display: 'flex', flexShrink: 0, width: 180, height: 80, alignSelf: 'start' }}

          /></a>
          {/* </a> */}
        </Grid>
        {/* Navbar */}
        <Grid display="flex" justifyContent="flex-end" alignItems="center" size="grow">
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'flex-end', mr: 2 }}>

            {/* ----------------------------------------------------------------------------------- */}
            {/* Начало */}
            <MenuButton
              variant="text"
              href='/'
              size="small"
              sx={{ ml: 2 }}
            >
              <Typography fontWeight={'bold'} fontSize={13}>
                Начало
              </Typography>
            </MenuButton>

            {/* ----------------------------------------------------------------------------------- */}
            {/* Курсове */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Курсове</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/courses'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      <Typography fontWeight={'bold'} fontSize={13}>Всички</Typography>
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/coming-soon'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Оферти
                    </MenuButton></>
                },
              ]}
            />

            {/* Учители */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Учители</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/instructors'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Нашите учители
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/new-instructor'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Стани учител
                    </MenuButton></>
                },
              ]}
            />
            {/* Блог */}
            {/* <MenuButton
              variant="text"
              href='/coming-soon'
              size="small"
              sx={{ ml: 2 }}
            >
              <Typography fontWeight={'bold'} fontSize={13}>
                Блог
              </Typography>
            </MenuButton> */}

            {/* ----------------------------------------------------------------------------------- */}
            {/* Още */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Още</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/competitions') ,
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Конкурси
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/webinars') ,
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Уебинари
                    </MenuButton></>
                },
                // {
                //   link: "/redirect",
                //   text: <>
                //     <MenuButton
                //       variant='text'
                //       size='small'
                //       sx={{ ml: 2 }}>
                //       Безплатни материали
                //     </MenuButton></>
                // },
                // {
                //   link: "/redirect",
                //   text: <>
                //     <MenuButton
                //       variant='text'
                //       size='small'
                //       sx={{ ml: 2 }}>
                //       Събития
                //     </MenuButton></>
                // },
              ]}
            />
            
            {/* ----------------------------------------------------------------------------------- */}
            {/* За нас */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span>За нас</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/about-us'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Кои сме ние?
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/contact-us'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Контакти
                    </MenuButton></>
                },
                // {
                //   onClick: () => navigate('/coming-soon'),
                //   text: <>
                //     <MenuButton
                //       variant='text'
                //       size='small'
                //       sx={{ ml: 2 }}>
                //       Активности
                //     </MenuButton></>
                // }
              ]}
            />



            {/* ----------------------------------------------------------------------------------- */}
            {/* Avatar */}

            {
              user ?
                <PopUpMenu mainEl={
                  <Tooltip title="Настройки на акаунта">
                    <IconButton
                      size="small"
                      sx={{ ml: 2 }}
                    >
                      <Avatar src={user ? user.image_url : null} sx={{ width: 32, height: 32 }}>
                        {user.image_url ? null : user.first_name.charAt(0)}
                      </Avatar>
                    </IconButton>
                  </Tooltip>}
                  children={[
                    {
                      onClick: () => navigate('/dashboard'),
                      text: <>
                        <ListItemIcon>
                          <PersonOutlineIcon fontSize="small" />
                        </ListItemIcon>Към Моя Профил</>
                    },
                    {
                      onClick: () => navigate('/saved'),
                      text: <>
                        <ListItemIcon>
                          <BookmarkIcon fontSize="small" />
                        </ListItemIcon>Запазени курсове</>
                    },
                    {
                      onClick: () => navigate('/cart'),
                      text: <>
                        <ListItemIcon>
                          <Settings fontSize="small" />
                        </ListItemIcon>Количка</>
                    },
                    {
                      // link: "/redirect",
                      onClick: () => logout(),
                      text: <>
                        <ListItemIcon >
                          <Logout fontSize="small" />
                        </ListItemIcon>Изход</>
                    }
                  ]}
                />
                :
                <>
                  <RedButton text='Регистрация' href="/register" size='small' sx={{ ml: 2 }} pX={2} />
                  <BlueButton text='Вход' href="/login" size='small' sx={{ ml: 2 }} pX={2} />
                </>
            }
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
